import { Navigate } from 'react-router-dom';

const PopulationInfoPage = () => <Navigate to="/lab/lab_2/maps/population" replace />;

export default PopulationInfoPage;
